import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {
    AppSettings,
    AUTH_SERVICE_IMPL,
    API_CLIENT_SERVICE_IMPL,
    ORDER_RETURN_SERVICE_IMPL,
    OrderReturnService,
    IAPIClientService,
    APIClientService,
    AuthenticationService,
    FlashMessageService,
    HttpStatusInterceptor,
    JwtInterceptor,
    SharedModule,
    ACCOUNTS_SERVICE_IMPL,
    AccountsService,
    TASKS_SERVICE_IMPL,
    TasksService,
    ORDERS_SERVICE_IMPL,
    OrdersService,
    GEOLOCATION_SERVICE_IMPL,
    GeolocationService,
    REALTIME_CLIENT_IMPL,
    RealtimeClientService,
} from 'shared';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { AppPolicyRoles } from './app.policies.config';
import { MARKUP_CHECKOUT_SERVICE_IMPL } from '../services/markup-checkout/imarkup-checkout.service';
import { MarkupCheckoutService } from '../services/markup-checkout/markup-checkout.service';
import { EMPLOYEE_AUTH_SERVICE_IMPL } from 'pm-src/services/employee-auth/i-employee-auth.service';
import { EmployeeAuthService } from 'pm-src/services/employee-auth/employee-auth.service';
import { AppSharedModule } from './modules/app-shared/app-shared.module';
import { EmployeeInterceptor } from './interceptors/employee.interceptor';
import { PMHttpStatusInterceptor } from './interceptors/pm-http-status.interceptor';
import { TRanslationService } from './modules/translation-manager/services/translation.service';
import { TRANSLATION_SERVICE_IMPL } from './modules/translation-manager/services/itranslation.service';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
        }),
        TranslateModule.forRoot({
            defaultLanguage: AppSettings.get('defaultLocale'),
            loader: {
                provide: TranslateLoader,
                useFactory: translateLoaderFactory,
                deps: [HttpClient],
            },
        }),
        SharedModule,
        AppSharedModule,
    ],
    providers: [
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy,
        },
        FlashMessageService,
        {
            provide: API_CLIENT_SERVICE_IMPL,
            useClass: APIClientService,
        },
        {
            provide: AUTH_SERVICE_IMPL,
            useFactory: (apiClient: IAPIClientService) => {
                return new AuthenticationService(apiClient, AppPolicyRoles, 'Resource-Manager-User');
            },
            deps: [API_CLIENT_SERVICE_IMPL],
        },
        {
            provide: EMPLOYEE_AUTH_SERVICE_IMPL,
            useClass: EmployeeAuthService,
        },
        {
            provide: REALTIME_CLIENT_IMPL,
            useClass: RealtimeClientService,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpStatusInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PMHttpStatusInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EmployeeInterceptor,
            multi: true,
        },
        {
            provide: GEOLOCATION_SERVICE_IMPL,
            useClass: GeolocationService,
        },
        {
            provide: TASKS_SERVICE_IMPL,
            useClass: TasksService,
        },
        {
            provide: ORDERS_SERVICE_IMPL,
            useClass: OrdersService,
        },
        {
            provide: ACCOUNTS_SERVICE_IMPL,
            useClass: AccountsService,
        },
        {
            provide: TRANSLATION_SERVICE_IMPL,
            useClass: TRanslationService,
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}

export function translateLoaderFactory(http: HttpClient): MultiTranslateHttpLoader {
    return new MultiTranslateHttpLoader(http, [
        {
            prefix: AppSettings.get('backendBaseURL') + '/translations/get/6/',
            suffix: '',
        },
        {
            prefix: AppSettings.get('backendBaseURL') + '/translations/get/5/',
            suffix: '',
        },
    ]);
}
